import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router'
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { AlertasComponent } from './alertas/alertas.component';
import { PopChannelsComponent } from './components/pop-channels/pop-channels.component';
import { FormContentChatComponent } from './formcontentchat/formcontentchat.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { PaymentHistoryComponent } from './paymenthistory/paymenthistory.component';
import { ServicesandEquipmentComponent } from './servicesandequipment/servicesandequipment.component';
import { BillsHistoryComponent } from './billshistory/billshistory.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { GestureConfig } from '@angular/material';

import {
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatNativeDateModule,
  MatTooltipModule, MatProgressSpinner
} from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { Service } from './services';
import { Bridge } from './bridge';
import { DatePipe } from '@angular/common';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { LoadingScreenMinComponent } from './components/loading-screen-min/loading-screen-min.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ProfileComponent } from './profile/profile.component';
import { CompanyInformationComponent } from './profile/components/company-information/company-information.component';
import { UpdateEmailComponent } from './profile/components/update-email/update-email.component';
import { ChangePasswordComponent } from './profile/components/change-password/change-password.component';
import { PostalAddressComponent } from './profile/components/postal-address/postal-address.component';
import { SecurityQuestionsComponent } from './profile/components/security-questions/security-questions.component';
import { PasswordValidatorComponent } from './components/password-validator/password-validator.component';
import { OptionsComponent } from './components/options/options.component';
import { FrequentQuestionsComponent } from './frequent-questions/frequent-questions.component';
import { BillsManagementComponent } from './bills-management/bills-management.component';
import { RegisterComponent } from './register/register.component';
import { RegisterSubscriberComponent } from './register/components/register-subscriber/register-subscriber.component';
import { SecurityCodeComponent } from './register/components/security-code/security-code.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { PasswordSetComponent } from './register/components/password-set/password-set.component';
import { ChatComponent } from './chat/chat.component';
import { ResetKeyComponent } from './forgotpassword/components/reset-key/reset-key.component';
import { SecurityCheckComponent } from './forgotpassword/components/security-check/security-check.component';
import { SecurityQuestionsPasswordComponent } from './forgotpassword/components/security-questions-password/security-questions-password.component';
import { PaperlessBoxComponent } from './components/paperless-box/paperless-box.component';
import { ForgotsubcriberComponent } from './forgotpassword/components/forgotsubcriber/forgotsubcriber.component';
import { PasswordSendingComponent } from './forgotpassword/components/password-sending/password-sending.component';
import { PopupQuestionComponent } from './home/components/popup-question/popup-question.component';
import { ModifyaccountsComponent } from './modifyaccounts/modifyaccounts.component';
import { TabNavComponent } from './components/tab-nav/tab-nav.component';
import { PaperlessComponent } from './paperless/paperless.component';
import { PaperlessModuleComponent } from './paperless/components/paperless-module/paperless-module.component';
import { DirectDebitComponent } from './direct-debit/direct-debit.component';
import { BanlistSelectComponent } from './components/banlist-select/banlist-select.component';
import { AffiliateCheckComponent } from './direct-debit/components/affiliate-check/affiliate-check.component';
import { ResumeCheckComponent } from './direct-debit/components/resume-check/resume-check.component';
import { AffiliateCreditComponent } from './direct-debit/components/affiliate-credit/affiliate-credit.component';
import { ResumeCreditComponent } from './direct-debit/components/resume-credit/resume-credit.component';
import { PrepaidComponent } from './home/components/prepaid/prepaid.component';
import { PostpaidComponent } from './home/components/postpaid/postpaid.component';
import { AddProductComponent } from './add-product/add-product.component';
import { FixedComponent } from './home/components/fixed/fixed.component';
import { EquilibrarComponent } from './home/components/equilibrar/equilibrar.component';
import { NetflixComponent } from './netflix/netflix.component';
import { NetflixTermsComponent } from './netflix/components/netflix-terms/netflix-terms.component';
import { NetflixQuestionsComponent } from './netflix/components/netflix-questions/netflix-questions.component';
import { NetflixSupportComponent } from './netflix/components/netflix-support/netflix-support.component';
import { NetflixSubsComponent } from './netflix/components/netflix-subs/netflix-subs.component';
import { TermsComponent } from './register/components/terms/terms.component';
import { SupportComponent } from './support/support.component';
import { CollapseComponent } from './components/collapse/collapse.component';
import { CollapseIptvComponent } from './iptv/components/collapse-iptv/collapse-iptv.component';
import { PaymentOptionsComponent } from './home/components/payment-options/payment-options.component';
import { TermsNetflixComponent } from './netflix/components/terms-netflix/terms-netflix.component';
import { GiveoneComponent } from './giveone/giveone.component';
import { TermsGiveoneComponent } from './giveone/components/terms-giveone/terms-giveone.component';
import { GiverechargeComponent } from './giverecharge/giverecharge.component';
import { TermsGiverechargeComponent } from './giverecharge/components/terms-giverecharge/terms-giverecharge.component';
import { BannerChatComponent } from './components/banner-chat/banner-chat.component';
import { ExtNavComponent } from './components/ext-nav/ext-nav.component';
import { UsageComponent } from './usage/usage.component';
import { PaymentComponentComponent } from './payment-component/payment-component.component';
import { ResumeComponent } from './payment-component/components/resume/resume.component';
import { ConfirmScreenComponent } from './payment-component/components/confirm-screen/confirm-screen.component';
import { BillingComponent } from './payment-component/components/billing/billing.component';
import { DataComponent } from './usage/components/data/data.component';
import { GraphicComponent } from './usage/components/graphic/graphic.component';
import { FixedUsageComponent } from './usage/components/fixed-usage/fixed-usage.component';
import { BannerHomeComponent } from './home/components/banner-home/banner-home.component';
import { DatapurchaseComponent } from './datapurchase/datapurchase.component';
import { CurrentplandatapurchaseComponent } from './datapurchase/components/current-plan/current-plan.component';
import { CarouselDatapurchaseComponent } from './datapurchase/components/carousel-datapurchase/carousel-datapurchase.component';
import { GraphicDatapurchaseComponent } from './datapurchase/components/graphic-datapurchase/graphic-datapurchase.component';
import { CurrentplanComponent } from './servicesandequipment/components/currentplan/currentplan.component';
import { MobileinfoComponent } from './servicesandequipment/components/mobileinfo/mobileinfo.component';
import { AdditionalsCurrentplanComponent } from './servicesandequipment/components/additionals-currentplan/additionals-currentplan.component';
import { PlandetailCurrentplanComponent } from './servicesandequipment/components/plandetail-currentplan/plandetail-currentplan.component';
import { ChangeplanComponent } from './changeplan/changeplan.component';
import { CurrentplanChangeplanComponent } from './changeplan/components/currentplan-changeplan/currentplan-changeplan.component';
import { CurrentplanChangeplanBoxComponent } from './changeplan/components/currentplan-changeplan-box/currentplan-changeplan-box.component';
import { PackagesCarouselComponent } from './changeplan/components/packages-carousel/packages-carousel.component';
import { ChangeplanTermsComponent } from './changeplan/components/changeplan-terms/changeplan-terms.component';
import { SelectedPlanComponent } from './changeplan/components/selected-plan/selected-plan.component';
import { SelectedPlanPrepaidComponent } from './changeplan/components/selected-plan-prepaid/selected-plan-prepaid.component';
import { planChangeConfirmationComponent } from './changeplan/components/plan-change-confirmation/plan-change-confirmation.component';
import { MyordersComponent } from './myorders/myorders.component';
import { ReferredComponent } from './referred/referred.component';
import { ReferredFrequentQuestionsComponent } from './referred/components/referred-frequent-questions/referred-frequent-questions.component';
import { ReferredTermsComponent } from './referred/components/referred-terms/referred-terms.component';
import { PopupReferComponent } from './referred/components/popup-refer/popup-refer.component';
import { PopupRedeemComponent } from './referred/components/popup-redeem/popup-redeem.component';
import { InternalreferredComponent } from './referred/internalreferred/internalreferred.component';
import { RedeemComponent } from './referred/redeem/redeem.component';
import { PopupReferPaperlessComponent } from './referred/components/popup-refer-paperless/popup-refer-paperless.component';
import { PopupInternalreferredValidateemailComponent } from './referred/components/popup-internalreferred-validateemail/popup-internalreferred-validateemail.component';
import { RechargeComponent } from './recharge/recharge.component';
import { TopUpBalanceComponent } from './recharge/components/top-up-balance/top-up-balance.component';
import { ReferredFaqCollapseComponent } from './referred/components/referred-faq-collapse/referred-faq-collapse.component';
import { GiftReceiverComponent } from './components/gift-receiver/gift-receiver.component';
import { PopupGiftAcceptedComponent } from './components/gift-receiver/components/popup-gift-accepted/popup-gift-accepted.component';
import { PopupGiftExpiredComponent } from './components/gift-receiver/components/popup-gift-expired/popup-gift-expired.component';
import { ConfirmationRechargeComponent } from './recharge/components/confirmation-recharge/confirmation-recharge.component';
import { PaymentRechargeComponent } from './recharge/components/payment-recharge/payment-recharge.component';
import { NotificationComponent } from './notification/notification.component';
import { PrepaidUsageComponent } from './usage/components/prepaid-usage/prepaid-usage.component';
import { ChangeplanPrepaidComponent } from './changeplan/components/changeplan-prepaid/changeplan-prepaid.component';
import { FaultreportComponent } from './faultreport/faultreport.component';
import { TypebreakdownComponent } from './faultreport/components/typebreakdown/typebreakdown.component';
import { LineonlyComponent } from './faultreport/components/lineonly/lineonly.component';
import { FaultconfirmationComponent } from './faultreport/components/faultconfirmation/faultconfirmation.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { ConfirmSendRechargeComponent } from './recharge/components/confirm-send-recharge/confirm-send-recharge.component';
import { EquilibrarPrepaidComponent } from './home/components/equilibrar-prepaid/equilibrar-prepaid.component';
import { PurchasesComponent } from './purchases/purchases.component';
import { PoliticsComponent } from './politics/politics.component';
import { PoliticaPrivacidadComponent } from './politics/components/politica-privacidad/politica-privacidad.component';
import { PoliticaPagoComponent } from './politics/components/politica-pago/politica-pago.component';
import { TerminosUsoComponent } from './politics/components/terminos-uso/terminos-uso.component';
import { PopupReferredProfileupdatedComponent } from './referred/components/popup-referred-profileupdated/popup-referred-profileupdated.component';
import { SmsCodeComponent } from './modifyaccounts/components/sms-code/sms-code.component';
import { ClubComponent } from './club/club.component';
import { ClubTermsComponent } from './club/components/club-terms/club-terms.component';
import { ClubQuestionsComponent } from './club/components/club-questions/club-questions.component';
import { OnlyAmountDirective } from './directives/only-amount.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { ZipCodeDirective } from './directives/zip-code.directive';
import { OnlycoinDirective } from './directives/onlycoin.directive';
import { PopupOutstandingBalanceComponent } from './referred/components/popup-outstanding-balance/popup-outstanding-balance.component';
import { ChangeplanTermsFixedComponent } from './changeplan/components/changeplan-terms-fixed/changeplan-terms-fixed.component';
import { LoginupdateComponent } from './loginupdate/loginupdate.component';
import { BillprepaidComponent } from './billprepaid/billprepaid.component';
import { FormContentChat2Component } from './formcontentchat2/formcontentchat2.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { PopupDatapurchaseTermsComponent } from './datapurchase/components/popup-datapurchase-terms/popup-datapurchase-terms.component';
import { TransitComponent } from './transit/transit.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { IptvComponent } from './iptv/iptv.component';
import { AuthenticationVerificationComponent } from './netflix/components/authentication-verification/authentication-verification.component';
import { PlanSelectionIptvComponent } from './iptv/components/plan-selection-iptv/plan-selection-iptv.component';
import { IptvTermsComponent } from './iptv/components/iptv-terms/iptv-terms.component';
import { IptvQuestionsComponent } from './iptv/components/iptv-questions/iptv-questions.component';
import { IptvSupportComponent } from './iptv/components/iptv-support/iptv-support.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { BuyProcessComponent } from './iptv/components/buy-process/buy-process.component';
import { PlanIptvComponent } from './iptv/components/buy-process/components/plan-iptv/plan-iptv.component';
import { AdditionalServiceComponent } from './iptv/components/buy-process/components/additional-service/additional-service.component';
import { PaymentShippingComponent } from './iptv/components/buy-process/components/payment-shipping/payment-shipping.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ChannelListComponent } from './iptv/components/channel-list/channel-list.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { IptvConfirmationComponent } from './iptv/components/iptv-confirmation/iptv-confirmation.component';
import { IptvCreateAccountComponent } from './iptv/components/iptv-create-account/iptv-create-account.component';
import { PopIptvCreateComponent } from './components/pop-iptv-create/pop-iptv-create.component';
import { MatIconModule } from '@angular/material/icon';
import { QuantityComponent } from './components/quantity/quantity.component';
import { CreditCardDirective } from './directives/credit-card.directive';
import { ExpirationYearDirective } from './directives/expiration-year.directive';
import { ExpirationMonthDirective } from './directives/expiration-month.directive';
import { CarouselOfItemsComponent } from './iptv/components/buy-process/components/additional-service/components/carousel-of-items/carousel-of-items.component';
import { ShippingAddressComponent } from './iptv/components/buy-process/components/shipping-address/shipping-address.component';
import { StreamingDeviceComponent } from './iptv/components/buy-process/components/streaming-device/streaming-device.component';
import { RechargeResponseComponent } from './changeplan/components/recharge-response/recharge-response.component';
import { RechargeDiffPlanComponent } from './changeplan/components/recharge-diff-plan/recharge-diff-plan.component';
import { ResetPasswordByEmailComponent } from './reset-password-by-email/reset-password-by-email.component';
import { PopUpTermsOffersComponent } from './iptv/components/plan-selection-iptv/components/pop-up-terms-offers/pop-up-terms-offers.component';
import { CreateAccountIptvComponent } from './iptv/components/buy-process/components/create-account-iptv/create-account-iptv.component';
import { PopTermsComponent } from './components/pop-terms/pop-terms.component';
import { OrderSummaryComponent } from './iptv/components/buy-process/components/order-summary/order-summary.component';
import { PermissionService } from './services/permission.service';
import { SplashComponent } from './splash/splash.component';
import { FlashPaymentComponent } from './flash-payment/flash-payment.component';
import { WayToPayComponent } from './flash-payment/components/way-to-pay/way-to-pay.component';
import { PaymentSummaryComponent } from './flash-payment/components/payment-summary/payment-summary.component';
import { PaymentConfirmationComponent } from './flash-payment/components/payment-confirmation/payment-confirmation.component';
import { AthPinpadComponent } from './flash-payment/components/payment-summary/ath-pinpad/ath-pinpad.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TwoDigitDecimalNumberDirective } from './flash-payment/flash-payment-core/directives/two-digit-decimal-number.directive';
import { PaymentFormComponent } from './flash-payment/components/way-to-pay/payment-form/payment-form.component';
import { CardCarouselComponent } from './flash-payment/components/way-to-pay/card-carousel/card-carousel.component';
import { OptionsForPaymentComponent } from './flash-payment/components/way-to-pay/options-for-payment/options-for-payment.component';
import { CardImageListComponent } from './flash-payment/components/way-to-pay/card-image-list/card-image-list.component';
import { AchComponent } from './flash-payment/components/way-to-pay/ach/ach.component';
import { CreditCardComponent } from './flash-payment/components/way-to-pay/credit-card/credit-card.component';
import { WalletComponent } from './flash-payment/components/way-to-pay/wallet/wallet.component';
import { OperationSuccessComponent } from './flash-payment/components/payment-confirmation/operation-success/operation-success.component';
import { OperationErrorComponent } from './flash-payment/components/payment-confirmation/operation-error/operation-error.component';
import { OperationWarningComponent } from './flash-payment/components/payment-confirmation/operation-warning/operation-warning.component';
import { AchSummaryComponent } from './flash-payment/components/payment-summary/ach-summary/ach-summary.component';
import { CardSummaryComponent } from './flash-payment/components/payment-summary/card-summary/card-summary.component';
import { HeadFormComponent } from './flash-payment/components/head-form/head-form.component';
import { DialogConfirmComponent } from './flash-payment/components/dialog-confirm/dialog-confirm.component';
import { DialogContinueComponent } from './flash-payment/components/way-to-pay/credit-card/dialog-continue/dialog-continue.component';

import { SafeHtmlPipe } from './safe-html/safe-html.component';
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    LoginComponent,
    FooterComponent,
    AlertasComponent,
    PopChannelsComponent,
    FormContentChatComponent,
    FormContentChat2Component,
    HomeComponent,
    PaymentHistoryComponent,
    ServicesandEquipmentComponent,
    BillsHistoryComponent,
    MenuComponent,
    LoadingScreenComponent,
    LoadingScreenMinComponent,
    ProfileComponent,
    CompanyInformationComponent,
    UpdateEmailComponent,
    ChangePasswordComponent,
    PostalAddressComponent,
    SecurityQuestionsComponent,
    PasswordValidatorComponent,
    OptionsComponent,
    FrequentQuestionsComponent,
    BillsManagementComponent,
    RegisterComponent,
    RegisterSubscriberComponent,
    SecurityCodeComponent,
    ForgotpasswordComponent,
    PasswordSetComponent,
    ChatComponent,
    ResetKeyComponent,
    SecurityCheckComponent,
    SecurityQuestionsPasswordComponent,
    PaperlessBoxComponent,
    ForgotsubcriberComponent,
    PasswordSendingComponent,
    PopupQuestionComponent,
    ModifyaccountsComponent,
    TabNavComponent,
    PaperlessComponent,
    PaperlessModuleComponent,
    DirectDebitComponent,
    BanlistSelectComponent,
    AffiliateCheckComponent,
    ResumeCheckComponent,
    AffiliateCreditComponent,
    ResumeCreditComponent,
    PrepaidComponent,
    PostpaidComponent,
    FixedComponent,
    EquilibrarComponent,
    NetflixComponent,
    NetflixTermsComponent,
    NetflixQuestionsComponent,
    NetflixSupportComponent,
    NetflixSubsComponent,
    TermsComponent,
    SupportComponent,
    CollapseComponent,
    CollapseIptvComponent,
    PaymentOptionsComponent,
    TermsNetflixComponent,
    GiveoneComponent,
    TermsGiveoneComponent,
    GiverechargeComponent,
    TermsGiverechargeComponent,
    BannerChatComponent,
    ExtNavComponent,
    UsageComponent,
    AddProductComponent,
    PaymentComponentComponent,
    ResumeComponent,
    ConfirmScreenComponent,
    BillingComponent,
    DataComponent,
    GraphicComponent,
    FixedUsageComponent,
    BannerHomeComponent,
    DatapurchaseComponent,
    CurrentplandatapurchaseComponent,
    CarouselDatapurchaseComponent,
    GraphicDatapurchaseComponent,
    CurrentplanComponent,
    MobileinfoComponent,
    AdditionalsCurrentplanComponent,
    PlandetailCurrentplanComponent,
    ChangeplanComponent,
    CurrentplanChangeplanComponent,
    CurrentplanChangeplanBoxComponent,
    PackagesCarouselComponent,
    ChangeplanTermsComponent,
    SelectedPlanComponent,
    SelectedPlanPrepaidComponent,
    planChangeConfirmationComponent,
    MyordersComponent,
    ReferredComponent,
    ReferredFrequentQuestionsComponent,
    ReferredTermsComponent,
    PopupReferComponent,
    PopupRedeemComponent,
    InternalreferredComponent,
    RedeemComponent,
    PopupReferPaperlessComponent,
    PopupInternalreferredValidateemailComponent,
    RechargeComponent,
    TopUpBalanceComponent,
    ReferredFaqCollapseComponent,
    TransactionsComponent,
    GiftReceiverComponent,
    PopupGiftAcceptedComponent,
    PopupGiftExpiredComponent,
    ConfirmationRechargeComponent,
    PaymentRechargeComponent,
    NotificationComponent,
    PrepaidUsageComponent,
    ChangeplanPrepaidComponent,
    FaultreportComponent,
    TypebreakdownComponent,
    LineonlyComponent,
    FaultconfirmationComponent,
    ConfirmSendRechargeComponent,
    EquilibrarPrepaidComponent,
    PurchasesComponent,
    PoliticsComponent,
    PoliticaPrivacidadComponent,
    PoliticaPagoComponent,
    TerminosUsoComponent,
    PopupReferredProfileupdatedComponent,
    SmsCodeComponent,
    ClubComponent,
    ClubTermsComponent,
    ClubQuestionsComponent,
    OnlyAmountDirective,
    OnlyNumberDirective,
    ZipCodeDirective,
    OnlycoinDirective,
    PopupOutstandingBalanceComponent,
    ChangeplanTermsFixedComponent,
    LoginupdateComponent,
    BillprepaidComponent,
    PopupDatapurchaseTermsComponent,
    TransitComponent,
    IptvComponent,
    AuthenticationVerificationComponent,
    PlanSelectionIptvComponent,
    IptvTermsComponent,
    IptvQuestionsComponent,
    IptvSupportComponent,
    BuyProcessComponent,
    PlanIptvComponent,
    AdditionalServiceComponent,
    PaymentShippingComponent,
    ChannelListComponent,
    IptvConfirmationComponent,
    IptvCreateAccountComponent,
    PopIptvCreateComponent,
    QuantityComponent,
    CreditCardDirective,
    ExpirationYearDirective,
    ExpirationMonthDirective,
    CarouselOfItemsComponent,
    ShippingAddressComponent,
    StreamingDeviceComponent,
    RechargeResponseComponent,
    RechargeDiffPlanComponent,
    ResetPasswordByEmailComponent,
    PopUpTermsOffersComponent,
    CreateAccountIptvComponent,
    PopTermsComponent,
    OrderSummaryComponent,
    SplashComponent,
    FlashPaymentComponent,
    WayToPayComponent,
    PaymentSummaryComponent,
    PaymentConfirmationComponent,
    AthPinpadComponent,
    TwoDigitDecimalNumberDirective,
    PaymentFormComponent,
    CardCarouselComponent,
    OptionsForPaymentComponent,
    CardImageListComponent,
    AchComponent,
    CreditCardComponent,
    WalletComponent,
    OperationSuccessComponent,
    OperationErrorComponent,
    OperationWarningComponent,
    AchSummaryComponent,
    CardSummaryComponent,
    HeadFormComponent,
    DialogConfirmComponent,
    DialogContinueComponent
  ],
  imports: [
    MatCarouselModule.forRoot(),
    NgxCaptchaModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatSelectModule,
    BrowserModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatDialogModule,
    MatExpansionModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    MatCheckboxModule,
    MatIconModule,
    HammerModule,
    RouterModule.forRoot([
      {
        path: 'login',
        component: LoginComponent,
        // canActivate: [PermissionService]
      },
      {
        path: 'home',
        component: LoginComponent,
        canActivate: [PermissionService]
      },
      {
        path: 'recharge',
        component: RechargeComponent,
        canActivate: [PermissionService],
        children: [
          {
            path: ':id/:amount',
            component: RechargeComponent,
            canActivate: [PermissionService]
          }
        ]
      },
      {
        path: 'myorders',
        component: MyordersComponent,
        canActivate: [PermissionService]
      },
      {
        path: 'datapurchase',
        component: DatapurchaseComponent,
        canActivate: [PermissionService]
      },
      {
        path: '',
        component: LoginComponent,
        //canActivate: [PermissionService]
      },
      {
        path: 'usage',
        component: UsageComponent,
        canActivate: [PermissionService]
      },
      {
        path: 'changeplan',
        component: ChangeplanComponent,
        //canActivate: [PermissionService]
      },
      {
        path: 'politics',
        component: PoliticsComponent,
        canActivate: [PermissionService],
        children: [
          {
            path: ':id',
            component: RegisterComponent,
            canActivate: [PermissionService]
          }
        ]
      },

      {
        path: 'loginupdate',
        component: LoginupdateComponent,
        canActivate: [PermissionService]
      },
      {
        path: 'billprepaid',
        component: BillprepaidComponent,
        canActivate: [PermissionService]
      },
      {
        path: 'buy_process',
        component: BuyProcessComponent,
        canActivate: [PermissionService],
      },

      {
        path: 'recover-password',
        component: ResetPasswordByEmailComponent
      },
      {
        path: 'flash-payment',
        canActivate: [PermissionService],
        component: FlashPaymentComponent
      },
      {
        path: 'mfa',
        canActivate: [PermissionService],
        loadChildren: () => import('./mfa/mfa.module').then(m => m.MfaModule)
      },
      {
        path: 'authentication-callback',
        canActivate: [PermissionService],
        loadChildren: () => import('./push-confirmation/push-confirmation.module').then(m => m.PushConfirmationModule)
      },
    ], routerOptions),
    CarouselModule.forRoot()],
  providers: [
    Service,
    Bridge,
    LoadingScreenComponent,
    DatePipe,
    {provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig}
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    AlertasComponent,
    PopIptvCreateComponent,
    PopChannelsComponent,
    FormContentChatComponent,
    FormContentChat2Component,
    PopupQuestionComponent,
    TermsComponent,
    TermsNetflixComponent,
    SmsCodeComponent,
    TermsGiveoneComponent,
    TermsGiverechargeComponent,
    ChangeplanTermsComponent,
    ReferredTermsComponent,
    PopupReferComponent,
    PopupRedeemComponent,
    PopupInternalreferredValidateemailComponent,
    PopupGiftAcceptedComponent,
    PopupGiftExpiredComponent,
    PopupReferPaperlessComponent,
    PopupOutstandingBalanceComponent,
    ChangeplanTermsFixedComponent,
    PopupDatapurchaseTermsComponent,
    PopUpTermsOffersComponent,
    PopTermsComponent
  ],
  exports: [AngularFireModule]
})
export class AppModule {
}
